import angular from 'angular';
import components from './components';

export default angular.module(
  'clientInsurance.scenes.listSaveQuotesInsurance',
  [components],
).name;
